import wrapper from '../analytics-wrapper';

export default {
  searchedShipments(searchQuery, resultsCount) {
    wrapper.track('Searched shipments', {
      'Search Query': searchQuery,
      'Results Count': resultsCount,
    });
  },
  clearedShipmentsSearch(searchQuery, resultsCount) {
    wrapper.track('Cleared shipments search', {
      'Search Query': searchQuery,
      'Results Count': resultsCount,
    });
  },
};
